import { render } from "./ThankYouView.vue?vue&type=template&id=147ddc63&lang=pug"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__